import { render, staticRenderFns } from "./DeleteFilter.vue?vue&type=template&id=33b8582f&"
import script from "./DeleteFilter.vue?vue&type=script&lang=js&"
export * from "./DeleteFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports